<template>
  <div id="tabDetail" style="width:100%">
    <div class="accordion">
      <div
        class="card nomargin"
        v-for="row in configurations"
        v-bind:key="row.code"
        :id="'accordionTabDetail' + row.code"
      >
        <button
          class="btn collapsed nopadding"
          type="button"
          data-toggle="collapse"
          :data-target="'#' + '_' + row.code"
          aria-expanded="false"
          :aria-controls="'_' + row.code"
        >
          <div class="card-header text-left" role="tab">
            {{ row.label }}
          </div>
        </button>
        <div
          :id="'_' + row.code"
          class="collapse show"
          :data-parent="'#accordionTabDetail' + row.code"
        >
          <div class="card-body" style="padding:1.5rem">
            <pageDetail
              :functions="functions"
              :configurations="row.pageConfigurations"
              :jsonValue="jsonValue"
            ></pageDetail>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import PageDetail from "@/components/PageDetail.vue";

export default {
  name: "tabDetail",
  inheritAttrs: false,
  components: {
    PageDetail
  },
  props: {
    functions: String,
    configurations: Array,
    jsonValue: Object
  }
}

</script>
